const ORDER_FIELD_ALIASES = {
	clientName: 'client.name',
};

export const normalizeCommercialOrder = (order) => {
	if (!order || typeof order !== 'object') return order;

	return Object.fromEntries(
		Object.entries(order).map(([field, direction]) => [ORDER_FIELD_ALIASES[field] || field, direction]),
	);
};

